const TestStates = {
	Archived: "archive",
	Draft: "draft",
	Published: "published",
	Closed: "close"
};
export default TestStates;
